import React, {useEffect, useRef} from 'react';

import {IBrandsCharacterGroupProps} from './IBrandsCharacterGroup';

import styles from './BrandsCharacterGroup.module.scss';

const BrandsCharacterGroup = ({
	character, children, type, handleCharGroupRef, triggerCharGroupRef}: IBrandsCharacterGroupProps
) => {
	const charGroupRef = useRef(null);

	useEffect(() => {
		if (type !== 'alphabetic-scroll') {
			return () => null;
		}

		if (charGroupRef?.current) {
			handleCharGroupRef && handleCharGroupRef(charGroupRef?.current);
		}
	}, [charGroupRef?.current, triggerCharGroupRef]);

	return (
		<ul className={styles['brands__char-group']} data-character={character} ref={charGroupRef}>
			{children}
		</ul>
	);
};

export default BrandsCharacterGroup;
